import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalService } from 'src/app/service/global.service';
import { AuthService } from 'src/app/service/auth.service';
import { SessionPersistenceService } from 'src/app/service/session-persistence.service';
import { AccountSharingAlertService } from 'src/app/service/account-sharing-alert.service';
import { AccountDeletionService, PENDING_DELETION_ROUTE } from 'src/app/service/account-deletion.service';
import { enviroment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css'],
})
export class AuthCallbackComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private authService: AuthService,
    private sessionPersistence: SessionPersistenceService,
    private accountSharingAlertService: AccountSharingAlertService,
    private accountDeletionService: AccountDeletionService,
  ) {}

  ngOnInit(): void {
    const params = this.route.snapshot.queryParamMap;
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error) {
      console.error(`[OAuth] ${error}: ${errorDescription}`);
      this.router.navigate(['/login'], { queryParams: { oauth_error: errorDescription ?? error } });
      return;
    }

    const code = params.get('code');

    if (!code) {
      this.router.navigate(['/login']);
      return;
    }

    const redirectUri = `${enviroment.BASE_URL}/auth/callback`;

    this.globalService.oauthCallback(code, redirectUri).subscribe({
      next: (response) => {
        // Identidade validada no provedor (Google/Apple), mas sem conta na plataforma
        // ainda: manda pro cadastro já com email/name preenchidos pelo provedor.
        if (response.status === 'REGISTRATION_REQUIRED') {
          this.router.navigate(['/create-account'], {
            queryParams: { email: response.email ?? '', name: response.name ?? '' },
          });
          return;
        }

        if (response.authenticationResult) {
          const { accessToken, idToken, refreshToken } = response.authenticationResult;
          if (accessToken) sessionStorage.setItem('token', accessToken);
          if (idToken) sessionStorage.setItem('idToken', idToken);
          if (refreshToken) sessionStorage.setItem('refreshToken', refreshToken);
        }
        if (response.sessionId) {
          sessionStorage.setItem('sessionId', response.sessionId);
        }
        // O login social não passa pelo storeTokens() do CognitoService, então o aviso
        // de acesso simultâneo precisa ser guardado aqui também — quem exibe é o shell.
        this.accountSharingAlertService.store(response.accountSharingAlert);
        // Também não passa pelo storeTokens(): registra aqui se a conta está em carência.
        this.accountDeletionService.applyLoginResponse(response);
        this.sessionPersistence.persist();
        // Em carência: não consome o postLoginRedirect, que serve se a pessoa desistir.
        if (this.accountDeletionService.isPending) {
          this.router.navigate([PENDING_DELETION_ROUTE]);
          return;
        }
        const redirect = this.authService.consumePostLoginRedirect();
        if (redirect) {
          this.router.navigateByUrl(redirect);
          return;
        }
        this.router.navigate(['/my-garage']);
      },
      error: () => {
        // 401 aqui já não significa "sem conta" (isso agora é um 200 com
        // status: "REGISTRATION_REQUIRED" acima) — é falha real de autenticação.
        this.router.navigate(['/login']);
      },
    });
  }
}
